/**
 * Extracts the path from the menu url. Guarantees there is *not* a trailing slash.
 * A trailing slash throws off route matching when applied as React Router's base.
 * @returns {string} a path without a trailing slash.
 */
export const deriveBasename = (menuUrl: string): string => {
  return new URL(menuUrl).pathname.replace(/\/?$/, '');
};
